module.exports = __webpack_public_path__ + "img/img-i5gam-advantage.7624ee33.png";